// extracted by mini-css-extract-plugin
export default {"mainContainer":"Stats_mainContainer__u55o2","statCard":"Stats_statCard__bRdso"};